export default __webpack_public_path__ + "static/media/order-confirmed.28c53daa.png";